/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as DevRouteImport } from './routes/dev'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgentsAgentIdRouteImport } from './routes/agents.$agentId'

const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dev': typeof DevRoute
  '/leaderboard': typeof LeaderboardRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dev': typeof DevRoute
  '/leaderboard': typeof LeaderboardRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dev': typeof DevRoute
  '/leaderboard': typeof LeaderboardRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/dev' | '/leaderboard' | '/agents/$agentId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/dev' | '/leaderboard' | '/agents/$agentId'
  id: '__root__' | '/' | '/dev' | '/leaderboard' | '/agents/$agentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DevRoute: typeof DevRoute
  LeaderboardRoute: typeof LeaderboardRoute
  AgentsAgentIdRoute: typeof AgentsAgentIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DevRoute: DevRoute,
  LeaderboardRoute: LeaderboardRoute,
  AgentsAgentIdRoute: AgentsAgentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
